// Flower Point - Black & Blanc Product Page

// Variant Radios
class VariantRadiosFp extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();
    this.updatePrice();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('input[type="radio"]:checked'), (input) => input.value);
  }

  updateMasterId() {
    const variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.currentVariant = variants.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantInput() {
    const input = document.querySelector('.product-variant-id');
    if (input) {
      input.value = this.currentVariant.id;
      input.disabled = false;
    }
  }

  updatePrice() {
    const priceEl = document.querySelector('.fp-price-amount');
    const comparePriceEl = document.querySelector('.fp-price-compare');
    
    if (priceEl && this.currentVariant) {
      priceEl.textContent = Shopify.formatMoney(this.currentVariant.price, window.themeVariables?.moneyFormat || '{{amount}}');
      
      if (comparePriceEl) {
        if (this.currentVariant.compare_at_price > this.currentVariant.price) {
          comparePriceEl.textContent = Shopify.formatMoney(this.currentVariant.compare_at_price, window.themeVariables?.moneyFormat || '{{amount}}');
          comparePriceEl.style.display = 'inline';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
    }
  }
}

customElements.define('variant-radios-fp', VariantRadiosFp);

// Tabs
class FpTabs extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.fp-tab-btn');
    this.contents = this.querySelectorAll('.fp-tab-content');
    
    this.buttons.forEach(btn => {
      btn.addEventListener('click', () => this.switchTab(btn.dataset.tab));
    });
  }

  switchTab(tabName) {
    this.buttons.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.tab === tabName);
    });
    
    this.contents.forEach(content => {
      content.classList.toggle('active', content.dataset.content === tabName);
    });
  }
}

customElements.define('fp-tabs', FpTabs);

// Thumbnail Click
document.addEventListener('DOMContentLoaded', () => {
  const thumbnails = document.querySelectorAll('.fp-thumb-petal');
  const mainImage = document.querySelector('.fp-main-image img');
  
  if (thumbnails && mainImage) {
    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', function() {
        const img = this.querySelector('img');
        if (img) {
          mainImage.src = img.src.replace(/width=\d+/, 'width=800');
        }
      });
    });
  }
});